import type { LocaleBundle } from '../types.js'

export const it: LocaleBundle = {
  code: 'it',
  name: 'Italiano',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'Home',
    'common:search': 'Cerca',
    'common:loading': 'Caricamento…',
    'common:save': 'Salva',
    'common:cancel': 'Annulla',
    'common:delete': 'Elimina',
    'common:create': 'Crea',
    'common:edit': 'Modifica',
    'common:show': 'Visualizza',
    'common:back': 'Indietro',
    'common:noRecords': 'Nessun record trovato.',
    'common:noRecordsHint': 'Inizia creando un nuovo {resource}.',
    'common:noMatchingRecords': 'Nessun record corrisponde ai filtri.',
    'common:clearFilters': 'Cancella filtri',
    'common:confirmDelete': 'Eliminare questo record?',
    'common:confirmAction': 'Conferma azione',
    'common:confirm': 'Conferma',
    'common:perPage': 'Per pagina',
    'common:page': 'Pagina',
    'common:of': 'di',
    'common:total': 'Totale',
    'auth:login': 'Accedi',
    'auth:logout': 'Esci',
    'auth:email': 'Email',
    'auth:password': 'Password',
    'auth:loginFailed': 'Credenziali non valide.',
    'errors:notFound': 'Non trovato.',
    'errors:forbidden': 'Non hai accesso a questa risorsa.',
    'errors:server': 'Qualcosa è andato storto. Riprova.',
    'common:resources': 'Risorse',
    'common:actions': 'Azioni',
    'action:notFound': 'L’azione «{action}» non è disponibile per questa risorsa.',
    'action:componentMissing': 'Nessun componente denominato «{component}» risulta registrato.',
    'action:componentMissingHint': 'Registralo nel ComponentLoader passato a <ModernAdminProvider components={…}>.',
    'action:loadFailed': 'Impossibile caricare l’azione.',
    'common:new': 'Nuovo',
    'common:rowsPerPage': 'Righe per pagina',
    'common:filter': 'Filtra {label}…',
    'validation:required': '{label} è obbligatorio',
    'validation:invalidNumber': '{label} deve essere un numero valido',
    'validation:invalidInteger': '{label} deve essere un intero',
    'validation:invalidEmail': '{label} deve essere un\u2019email valida',
    'validation:invalidUrl': '{label} deve essere un URL valido',
    'validation:invalidDate': '{label} deve essere una data valida',
    'validation:invalidUuid': '{label} deve essere un UUID valido',
    'validation:tooShort': '{label} deve contenere almeno {min} caratteri',
    'validation:tooLong': '{label} deve contenere al massimo {max} caratteri',
    'validation:notInList': '{label} ha un valore non valido',
    'validation:emptySelection': 'Seleziona almeno un valore per {label}',
    'toast:created': 'Creato con successo',
    'toast:saved': 'Salvato con successo',
    'toast:deleted': 'Eliminato con successo',
    'toast:createFailed': 'Creazione non riuscita',
    'toast:saveFailed': 'Salvataggio non riuscito',
    'toast:deleteFailed': 'Eliminazione non riuscita',
    'toast:loadFailed': 'Caricamento non riuscito',
    'toast:validationFailed': 'Correggi gli errori e riprova',
    'common:close': 'Chiudi',
    'common:export': 'Esporta',
    'export:title': 'Esporta record',
    'export:description': 'Scarica tutti i record corrispondenti di {resource} in un unico file.',
    'export:csvHint': 'Valori separati da virgola',
    'export:jsonHint': 'Array JSON strutturato',
    'export:downloading': 'Preparazione del download…',
    'export:progress': 'Caricati {loaded} di {total}…',
    'export:exported': '{count} record esportati',
    'export:exportFailed': 'Esportazione non riuscita',
    'common:apply': 'Applica',
    'common:clear': 'Cancella',
    'common:filters': 'Filtri',
    'common:columns': 'Colonne',
    'common:toggleColumns': 'Mostra colonne',
    'common:openMenu': 'Apri menu',
    'common:refresh': 'Aggiorna',
    'common:copy': 'Copia',
    'common:copied': 'Copiato!',
    'common:applyFilters': 'Applica filtri',
    'common:clearAll': 'Cancella tutto',
    'common:any': 'Qualsiasi',
    'common:yes': 'Sì',
    'common:no': 'No',
    'common:filterPlaceholder': 'Filtra…',
    'common:loadFailed': 'Caricamento non riuscito: {error}',
    'common:theme': 'Tema',
    'common:language': 'Lingua',
    'common:toggleTheme': 'Cambia tema',
    'common:clearSelection': 'Cancella selezione',
    'common:searchPlaceholder': 'Cerca…',
    'home:searchResources': 'Cerca risorse…',
    'home:noMatchingResources': 'Nessuna risorsa corrispondente trovata.',
    'globalSearch:title': 'Ricerca globale',
    'globalSearch:description': 'Cerca tra tutte le risorse e i record.',
    'globalSearch:trigger': 'Cerca…',
    'globalSearch:placeholder': 'Cerca in tutte le risorse…',
    'globalSearch:hint': 'Inizia a digitare per cercare in tutte le risorse.',
    'globalSearch:noResults': 'Nessun record corrispondente.',
    'globalSearch:error': 'Ricerca non riuscita. Riprova.',
    'globalSearch:hotkey': 'Apri ricerca globale',
    'globalSearch:matchedIn': 'in {field}',
    'globalSearch:recent': 'Ricerche recenti',
    'globalSearch:clearRecent': 'Cancella',
    'globalSearch:showAllIn': 'Mostra tutto in {resource}',
    'common:pageOf': 'Pagina {page} di {total}',
    'common:firstPage': 'Prima pagina',
    'common:previousPage': 'Pagina precedente',
    'common:nextPage': 'Pagina successiva',
    'common:lastPage': 'Ultima pagina',
    'common:recordsCount': '{count} record',
    'common:selectedCount': '{count} selezionati',
    'common:selectRow': 'Seleziona riga',
    'common:selectAll': 'Seleziona tutto',
    'common:deleteSelected': 'Elimina selezionati',
    'common:bulkDeleteConfirm': 'Eliminare {count} record selezionati?',
    'toast:bulkDeleted': '{count} record eliminati',
    'toast:bulkDeleteFailed': 'Impossibile eliminare i record',
    'common:from': 'Da',
    'common:to': 'A',
    'common:sortBy': 'Ordina per',
    'common:next': 'Avanti',
    'common:previous': 'Indietro',
    'common:relatedRecords': 'Record correlati',
    'common:viewAll': 'Vedi tutti',
    'common:noRelatedRecords': 'Nessun record correlato.',
    'common:preview': 'Anteprima',
    'common:download': 'Scarica',
    'common:openInNewTab': 'Apri in una nuova scheda',
    'common:format': 'Formatta',
    'common:invalidJson': 'JSON non valido',
    'common:showPassword': 'Mostra password',
    'common:hidePassword': 'Nascondi password',
    'common:shortcutsHelp': 'Scorciatoie da tastiera',
    'common:shortcutsEmpty': 'Nessuna scorciatoia disponibile in questa schermata.',
    'auth:title': 'Accedi',
    'auth:subtitle': 'Inserisci email e password per accedere',
    'auth:tagline': 'Il pannello di amministrazione moderno per qualsiasi stack.',
    'auth:orContinueWith': 'O continua con',
    'auth:continueWith': 'Continua con {provider}',
    'common:chooseFile': 'Scegli file',
    'common:chooseFiles': 'Scegli file',
    'common:dragAndDrop': 'Trascina o',
    'common:chooseAFile': 'scegli un file',
    'common:addMoreFiles': 'aggiungi altri file',
    'common:uploading': 'Caricamento…',
    'common:uploadingFile': 'Caricamento di {name}…',
    'common:removeFile': 'Rimuovi file',
    'common:uploadFailed': 'Caricamento fallito',
    'common:dismiss': 'Chiudi',
    'common:openCalendar': 'Apri calendario',
    'common:time': 'Orario',
    'common:downloadFailed': 'Download fallito',
    'richtext:bold': 'Grassetto',
    'richtext:italic': 'Corsivo',
    'richtext:strikethrough': 'Barrato',
    'richtext:inlineCode': 'Codice inline',
    'richtext:heading': 'Intestazione {level}',
    'richtext:bulletList': 'Elenco puntato',
    'richtext:numberedList': 'Elenco numerato',
    'richtext:blockquote': 'Blocco citazione',
    'richtext:horizontalRule': 'Linea orizzontale',
    'richtext:insertLink': 'Inserisci collegamento',
    'richtext:undo': 'Annulla',
    'richtext:redo': 'Ripeti',
    'richtext:source': 'Sorgente ({format})',
    'richtext:splitView': 'Vista divisa',
    'richtext:visualEditor': 'Editor visivo',
    'richtext:fullscreen': 'Schermo intero',
    'richtext:exitFullscreen': 'Esci dallo schermo intero',
    'richtext:urlPrompt': 'URL',
    'common:saving': 'Salvataggio…',
    'common:done': 'Fatto',
    'settings:menuItem': 'Impostazioni',
    'settings:noSectionsConfigured': 'Per questa installazione non sono disponibili sezioni delle impostazioni.',
    'settings:apiKeys.title': 'Chiavi API',
    'settings:apiKeys.description': 'Token di accesso programmatico all\'API admin. Ogni chiave porta con sé un set di permessi che limita le risorse e le azioni che può invocare.',
    'settings:apiKeys.actions.create': 'Nuova chiave',
    'settings:apiKeys.actions.edit': 'Modifica',
    'settings:apiKeys.actions.revoke': 'Revoca',
    'settings:apiKeys.empty.title': 'Nessuna chiave API',
    'settings:apiKeys.empty.description': 'Crea la prima chiave per concedere accesso programmatico.',
    'settings:apiKeys.columns.name': 'Nome',
    'settings:apiKeys.columns.start': 'Prefisso',
    'settings:apiKeys.columns.permissions': 'Permessi',
    'settings:apiKeys.columns.expiresAt': 'Scade',
    'settings:apiKeys.columns.enabled': 'Attiva',
    'settings:apiKeys.columns.actions': 'Azioni',
    'settings:apiKeys.lastUsed': 'Ultimo utilizzo {date}',
    'settings:apiKeys.expiresNever': 'Mai',
    'settings:apiKeys.permissions.resource': 'Risorsa',
    'settings:apiKeys.permissions.actions': 'Azioni',
    'settings:apiKeys.permissions.selectAll': 'Seleziona tutto',
    'settings:apiKeys.permissions.clearAll': 'Pulisci tutto',
    'settings:apiKeys.permissions.none': 'Nessun permesso',
    'settings:apiKeys.permissions.summary': '{resources} risorse · {actions} azioni',
    'settings:apiKeys.permissions.noResources': 'Nessuna risorsa registrata.',
    'settings:apiKeys.permissions.selectAllResources': 'Seleziona tutte le risorse e le azioni',
    'settings:apiKeys.permissions.clearAllResources': 'Cancella tutte le risorse e le azioni',
    'settings:apiKeys.editor.titleCreate': 'Nuova chiave API',
    'settings:apiKeys.editor.titleEdit': 'Modifica chiave API',
    'settings:apiKeys.editor.description': 'Scegli un nome descrittivo e concedi solo le risorse e azioni di cui questa chiave ha realmente bisogno.',
    'settings:apiKeys.editor.name': 'Nome',
    'settings:apiKeys.editor.namePlaceholder': 'es. bot di deploy CI',
    'settings:apiKeys.editor.expiresInDays': 'Scade in (giorni)',
    'settings:apiKeys.editor.expiresPlaceholder': 'mai',
    'settings:apiKeys.editor.expiresHint': 'Lascia vuoto per non scadere mai. Massimo 3650 giorni.',
    'settings:apiKeys.editor.permissions': 'Permessi',
    'settings:apiKeys.editor.selectedActions': '{count} selezionate',
    'settings:apiKeys.created.title': 'Chiave API creata',
    'settings:apiKeys.created.description': 'Copia la chiave ora — non sarà più mostrata.',
    'settings:apiKeys.created.warning': 'Questa è l\'unica volta in cui vedrai la chiave completa. Conservala in un luogo sicuro.',
    'settings:apiKeys.created.reveal': 'Mostra chiave',
    'settings:apiKeys.created.hide': 'Nascondi chiave',
    'settings:apiKeys.created.copy': 'Copia',
    'settings:apiKeys.created.copied': 'Copiata',
    'settings:apiKeys.notice.revoked': 'Chiave API revocata',
    'settings:apiKeys.notice.updated': 'Chiave API aggiornata',
    'settings:apiKeys.notice.copied': 'Copiata negli appunti',
    'settings:apiKeys.notice.copyFailed': 'Impossibile copiare negli appunti',
    'settings:apiKeys.confirmRevoke.title': 'Revoca chiave API',
    'settings:apiKeys.confirmRevoke.description': 'Revocare «{name}»? Qualsiasi servizio che utilizza questa chiave smetterà di funzionare immediatamente.',
    'settings:webhooks.title': 'Webhooks',
    'settings:webhooks.description': 'Send signed HTTP notifications when records are created, updated, or deleted.',
    'settings:webhooks.actions.create': 'New webhook',
    'settings:webhooks.actions.test': 'Test',
    'settings:webhooks.notice.saved': 'Webhook saved',
    'settings:webhooks.notice.deleted': 'Webhook deleted',
    'settings:webhooks.notice.testQueued': 'Test notification queued',
    'settings:webhooks.confirmDelete.title': 'Delete webhook',
    'settings:webhooks.confirmDelete.description': 'Delete "{name}"? Delivery history for this webhook will also be removed.',
    'settings:webhooks.empty.title': 'No webhooks yet',
    'settings:webhooks.empty.description': 'Create a webhook to notify external systems about admin changes.',
    'settings:webhooks.columns.name': 'Name',
    'settings:webhooks.columns.resource': 'Resource',
    'settings:webhooks.columns.events': 'Events',
    'settings:webhooks.columns.enabled': 'Enabled',
    'settings:webhooks.columns.actions': 'Actions',
    'settings:webhooks.deliveries.title': 'Recent deliveries',
    'settings:webhooks.deliveries.status': 'Status',
    'settings:webhooks.deliveries.event': 'Event',
    'settings:webhooks.deliveries.attempt': 'Attempt',
    'settings:webhooks.deliveries.response': 'Response',
    'settings:webhooks.deliveries.createdAt': 'Created',
    'settings:webhooks.editor.titleCreate': 'New webhook',
    'settings:webhooks.editor.titleEdit': 'Edit webhook',
    'settings:webhooks.editor.description': 'Choose target URL, events, filters, and optional payload projection.',
    'settings:webhooks.editor.name': 'Name',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Resource',
    'settings:webhooks.editor.allResources': 'All resources',
    'settings:webhooks.editor.secret': 'Signing secret',
    'settings:webhooks.editor.enabled': 'Enabled',
    'settings:webhooks.editor.events': 'Events',
    'settings:webhooks.editor.payloadFields': 'Payload fields',
    'settings:webhooks.editor.payloadFieldsHint': 'Restrict the payload to specific fields. Leave all unchecked to include the full record. Useful to avoid sending sensitive columns.',
    'settings:webhooks.editor.headers': 'Headers',
    'settings:webhooks.editor.headersHint': 'Custom HTTP headers sent with every delivery.\n\nExample:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nUseful for auth tokens, Slack incoming webhook URLs stored as a header, or endpoint-specific signatures.',
    'settings:webhooks.editor.filters': 'Filters',
    'settings:webhooks.editor.filtersHint': 'Deliver only when the record matches all conditions (AND semantics). Leave empty to deliver for every matching event.\n\nExample:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nNote: delete events bypass field filters because the record no longer exists.',
    'settings:webhooks.editor.secretHint': 'Random string used to sign each delivery with HMAC-SHA256. Verify the X-Webhook-Signature header on your server to ensure the request is genuine.',
    'chart:dashboard': 'Dashboard',
    'chart:addChart': 'Aggiungi grafico',
    'chart:newChart': 'Nuovo grafico',
    'chart:editChart': 'Modifica grafico',
    'chart:deleteChart': 'Rimuovi grafico',
    'chart:noCharts': 'Nessun grafico',
    'chart:noChartsHint': 'Aggiungi un grafico per iniziare a monitorare i dati.',
    'chart:addGroup': 'Aggiungi gruppo',
    'chart:newGroup': 'Nuovo gruppo',
    'chart:editGroup': 'Modifica gruppo',
    'chart:deleteGroup': 'Rimuovi gruppo',
    'chart:saveGroup': 'Salva gruppo',
    'chart:groupName': 'Nome del gruppo',
    'chart:groupNamePlaceholder': 'es. Metriche vendite',
    'chart:groupNameRequired': 'Il nome del gruppo è obbligatorio',
    'chart:groupOrder': 'Ordine del gruppo',
    'chart:order': 'Ordine',
    'chart:orderHint': 'I valori più bassi vengono visualizzati per primi.',
    'chart:moveToGroup': 'Sposta nel gruppo',
    'chart:moveChart': 'Sposta grafico',
    'chart:moveGroup': 'Gruppo',
    'chart:moveNoGroups': 'Nessun gruppo ancora.',
    'chart:moveNoGroupsHint': 'Crea prima un gruppo per organizzare i grafici.',
    'chart:deleteChartConfirm': 'Rimuovere questo grafico?',
    'chart:deleteChartConfirmHint': 'Questa azione non può essere annullata.',
    'chart:deleteGroupConfirm': 'Rimuovere questo gruppo?',
    'chart:deleteGroupConfirmHint': 'Il gruppo e i {count} grafici al suo interno verranno eliminati definitivamente.',
    'chart:title': 'Titolo',
    'chart:titlePlaceholder': 'es. Nuovi utenti al giorno',
    'chart:untitled': 'Senza titolo',
    'chart:chartType': 'Tipo di grafico',
    'chart:resource': 'Risorsa',
    'chart:groupBy': 'Raggruppa per',
    'chart:step': 'Passo',
    'chart:metric': 'Metrica',
    'chart:aggregateField': 'Campo di aggregazione',
    'chart:selectField': 'Seleziona campo…',
    'chart:saveChart': 'Salva grafico',
    'chart:typeLine': 'Linea',
    'chart:typeArea': 'Area',
    'chart:typeBar': 'Barre',
    'chart:typePie': 'Torta',
    'chart:stepDay': 'Giorno',
    'chart:stepWeek': 'Settimana',
    'chart:stepMonth': 'Mese',
    'chart:stepYear': 'Anno',
    'chart:metricCount': 'Conteggio',
    'chart:metricSum': 'Somma',
    'chart:metricAvg': 'Media',
    'chart:noData': 'Nessun dato per il periodo selezionato',
    'chart:loadError': 'Impossibile caricare i dati del grafico',
    'chart:value': 'Valore',
    'dashboard:vis': 'Visualizzazione',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': 'Linea',
    'dashboard:visArea': 'Area',
    'dashboard:visBar': 'Barre',
    'dashboard:visPie': 'Torta',
    'dashboard:metricCount': 'Conteggio',
    'dashboard:metricSum': 'Somma',
    'dashboard:metricAvg': 'Media',
    'dashboard:metricMin': 'Min',
    'dashboard:metricMax': 'Max',
    'dashboard:builder.range': 'Periodo',
    'dashboard:builder.filters': 'Filtri',
    'dashboard:builder.filtersHint': "Limita il dataset prima dell'aggregazione. Spunta un filtro per mostrarlo sopra al grafico.",
    'dashboard:builder.quickFilterHint': 'Mostra questo filtro sopra al grafico nella dashboard.',
    'dashboard:builder.quickFilterToggle': 'Esporre {field} come filtro rapido',
    'dashboard:range.7d': '7g',
    'dashboard:range.30d': '30g',
    'dashboard:range.90d': '90g',
    'dashboard:range.1y': '1a',
    'dashboard:range.all': 'Tutto',
    'dashboard:range.custom': 'Personalizzato',
    'dashboard:widget.previousPeriod': 'vs. periodo precedente',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': 'Riduci a metà larghezza',
    'dashboard:widget.expand': 'Espandi a tutta la riga',
    'dashboard:widget.toggleSql': 'Mostra SQL',
    'dashboard:widget.unsupported': 'I grafici non sono ancora supportati per il tuo database.',
    'dashboard:widget.truncatedWarning': 'Visualizzazione di dati parziali — troppe righe per aggregare l’intero intervallo.',
    'dashboard:widget.showAll': 'Mostra tutto',
    'dashboard:widget.hideAll': 'Nascondi tutto',
    'dashboard:seriesTotal': 'Totale',
    'dashboard:seriesOther': 'Altro',
    'dashboard:seriesNull': 'Vuoto',
    'dashboard:builder.dateField': 'Campo data',
    'dashboard:builder.dateFieldHint': "L'asse X è raggruppato per questa colonna data.",
    'dashboard:builder.secondaryGroupBy': 'Suddivisione',
    'dashboard:builder.noBreakdown': 'Serie singola',
    'dashboard:builder.topN': 'Max. serie',
    'dashboard:builder.width': 'Larghezza',
    'dashboard:width.half': 'Metà',
    'dashboard:width.full': 'Riga intera',
    'dashboard:builder.comparePrevious': 'Confronta con il periodo precedente',
    'dashboard:builder.comparePreviousHint': 'Sovrappone il periodo precedente di pari durata come linea tratteggiata e mostra la variazione accanto al titolo.',
    'dashboard:builder.comparePreviousDisabled': 'Non disponibile con una suddivisione.',
    'dashboard:builder.transform': 'Trasformazione dei valori',
    'dashboard:builder.transformHint': 'Applicata ai valori prima della visualizzazione — ad es. dividere per 100 per mostrare i centesimi come euro.',
    'dashboard:builder.transformAdd': 'Aggiungi passaggio',
    'dashboard:builder.transformRemove': 'Rimuovi passaggio',
    'dashboard:builder.opDivide': 'Dividi per',
    'dashboard:builder.opMultiply': 'Moltiplica per',
    'dashboard:builder.opAdd': 'Aggiungi',
    'dashboard:builder.opSubtract': 'Sottrai',
    'dashboard:builder.format': 'Formato dei valori',
    'dashboard:builder.formatStyle': 'Stile',
    'dashboard:builder.formatNumber': 'Numero',
    'dashboard:builder.formatCurrency': 'Valuta',
    'dashboard:builder.formatPercent': 'Percentuale',
    'dashboard:builder.formatCurrencyCode': 'Codice valuta',
    'dashboard:builder.formatDecimals': 'Decimali',
    'dashboard:builder.formatCompact': 'Numeri compatti (12,5 mila)',
    'dashboard:builder.formatPrefix': 'Prefisso',
    'dashboard:builder.formatSuffix': 'Suffisso',
    'dashboard:builder.color': 'Colore della serie',
    'dashboard:widget.previousSeries': '{label} (periodo precedente)',
    'dashboard:widget.editColors': 'Modifica colori',
    'dashboard:widget.colorsTitle': 'Colori delle serie',
    'dashboard:widget.colorCustom': 'Personalizzato',
    'dashboard:widget.colorAuto': 'Automatico',
    'dashboard:widget.colorPick': 'Scegli un colore',
    'dashboard:builder.tabData': 'Dati',
    'dashboard:builder.tabDisplay': 'Visualizzazione',
    'dashboard:builder.tabFilters': 'Filtri',
    'dashboard:builder.filtersEmpty': 'Questa risorsa non ha campi filtrabili.',
    'history:revisions': 'Revisioni',
    'history:noRevisions': 'Nessuna revisione ancora',
    'history:loadError': 'Impossibile caricare la cronologia modifiche',
    'history:revert': 'Ripristina',
    'history:confirmRevert': 'Ripristinare questa revisione?',
    'history:revertSuccess': 'Revisione ripristinata',
    'history:revertFailed': 'Impossibile ripristinare la revisione',
    'history:unknownUser': 'Utente sconosciuto',
    'history:changes': 'modifiche',
    'history:compareTo': 'Confronta con',
    'history:storedDiff': 'Diff modifica',
    'history:op.create': 'Creato',
    'history:op.update': 'Aggiornato',
    'history:op.delete': 'Eliminato',
    'diff:added': 'Aggiunto',
    'diff:changed': 'Modificato',
    'diff:removed': 'Rimosso',
    'diff:before': 'Prima',
    'diff:after': 'Dopo',
    'diff:noChanges': 'Nessuna modifica ai campi registrata',
    'audit:title': 'Attività',
    'audit:resource': 'Risorsa',
    'audit:action': 'Azione',
    'audit:recordId': 'ID record',
    'audit:userId': 'ID utente',
    'audit:allResources': 'Tutte le risorse',
    'audit:allActions': 'Tutte le azioni',
    'audit:noEvents': 'Nessuna attività ancora',
    'audit:records': 'record',
    'audit:loadError': 'Impossibile caricare l’attività',
    'audit:by': 'da {user}',
    'audit:viewRecord': 'Apri record',
    'audit:viewChanges': 'Mostra modifiche',
    'audit:hideChanges': 'Nascondi modifiche',
    'audit:noDiff': 'Dettagli delle modifiche non disponibili',
    'audit:loadDiffError': 'Impossibile caricare le modifiche',
    'audit:action.new': 'Record creato',
    'audit:action.edit': 'Record aggiornato',
    'audit:action.delete': 'Record eliminato',
    'audit:action.bulkDelete': 'Record eliminati',
    'audit:action.login': 'Accesso effettuato',
    'audit:action.apiKeyCreate': 'Chiave API creata',
    'audit:action.apiKeyUpdate': 'Chiave API aggiornata',
    'audit:action.apiKeyDelete': 'Chiave API eliminata',
    'audit:virtualResource.auth': 'Autenticazione',
    'audit:virtualResource.apiKeys': 'Chiavi API',
    'audit:prevPage': 'Precedente',
    'audit:nextPage': 'Successivo',
    'audit:dateRangePlaceholder': 'Seleziona intervallo di date',
    'keyValue:noMatches': 'Nessuna corrispondenza — premi Invio per mantenere "{value}".',
    'aiAssistant:queue.cancel': 'Rimuovi dalla coda',
    'aiAssistant:title': 'Assistente IA',
    'aiAssistant:fab.label': 'Apri assistente IA',
    'aiAssistant:fab.short': 'IA',
    'aiAssistant:description': 'Fai domande su record, relazioni, report e tendenze dei dati.',
    'aiAssistant:notConfigured.title': 'Assistente non configurato',
    'aiAssistant:notConfigured.description': 'Aggiungi la chiave API OpenRouter nelle impostazioni per abilitare l’assistente IA in sola lettura.',
    'aiAssistant:notConfigured.openSettings': 'Apri impostazioni',
    'aiAssistant:tryAsking': 'Prova a chiedere:',
    'aiAssistant:tryAsking.example1': 'Quali clienti hanno il maggior numero di post?',
    'aiAssistant:tryAsking.example2': 'Mostra i record creati di recente per una risorsa.',
    'aiAssistant:tryAsking.example3': 'Spiega le relazioni tra record specifici.',
    'aiAssistant:thinking': 'In elaborazione',
    'aiAssistant:thinkingProgress': 'In elaborazione ({progress}%)',
    'aiAssistant:input.placeholder': 'Chiedi informazioni sui tuoi dati…',
    'aiAssistant:input.hint': 'Invio per inviare · Maiusc+Invio per una nuova riga',
    'aiAssistant:send': 'Invia messaggio',
    'aiAssistant:newChat': 'Nuova chat',
    'aiAssistant:history': 'Cronologia chat',
    'aiAssistant:history.empty': 'Nessuna chat precedente',
    'aiAssistant:noText': 'Ecco i record correlati trovati:',
    'aiAssistant:fallback.noToolResult': 'La richiesta è stata eseguita, ma il modello non ha restituito una risposta testuale. Prova a precisare la domanda o abilita i log di debug per controllare il risultato dello strumento.',
    'aiAssistant:fallback.noRows': 'Nessun record trovato per questa richiesta.',
    'aiAssistant:fallback.rowsFound': 'Righe trovate: {count}.',
    'aiAssistant:taskFailed': 'Operazione dell’assistente IA non riuscita',
    'aiAssistant:settings.title': 'Assistente IA',
    'aiAssistant:settings.description': 'Configura il widget di chat IA flottante, il modello e il comportamento dell’assistente lato server.',
    'aiAssistant:settings.enabled': 'Attivato',
    'aiAssistant:settings.disabled': 'Disattivato',
    'aiAssistant:settings.configured': 'Configurato',
    'aiAssistant:settings.apiKeyRequired': 'Chiave API richiesta',
    'aiAssistant:settings.readOnly': 'Sola lettura',
    'aiAssistant:settings.provider': 'Provider: {provider}',
    'aiAssistant:settings.enableLabel': 'Abilita assistente',
    'aiAssistant:settings.enableHint': 'Controlla la visibilità del widget flottante e dell’endpoint di chat.',
    'aiAssistant:settings.modelLabel': 'Modello OpenRouter',
    'aiAssistant:settings.apiKeyLabel': 'Chiave API OpenRouter',
    'aiAssistant:settings.apiKeyHint': 'Lascia vuoto per mantenere la chiave già salvata sul server.',
    'aiAssistant:settings.systemPromptLabel': 'Override del prompt di sistema',
    'aiAssistant:settings.systemPromptPlaceholder': 'Istruzioni opzionali specifiche del progetto per l’assistente',
    'aiAssistant:settings.accessTitle': 'Modello di accesso',
    'aiAssistant:settings.accessDescription': 'L’assistente attuale è limitato all’ispezione in sola lettura dei record tramite le azioni delle risorse di amministrazione.',
    'aiAssistant:settings.futureToolsReady': 'Strumenti futuri pronti',
    'aiAssistant:settings.save': 'Salva impostazioni',
    'aiAssistant:settings.saving': 'Salvataggio…',
    'aiAssistant:settings.saved': 'Impostazioni dell’assistente IA salvate',
    'aiAssistant:settings.empty': 'Nessuna impostazione disponibile.',
    'aiFill:button': 'Compila con IA',
    'aiFill:dialogTitle': 'Compila il modulo da una foto',
    'aiFill:dialogDescription': 'Carica un\u2019immagine — l\u2019IA estrarrà i valori e compilerà il modulo.',
    'aiFill:fillButton': 'Riconosci',
    'aiFill:processing': 'Riconoscimento dell\u2019immagine\u2026',
    'aiFill:success': '{count} campo/i compilato/i',
    'aiFill:errorNoFields': 'Questa risorsa non ha campi compilabili dall\u2019IA.',
    'aiFill:errorGeneric': 'Compilazione tramite IA non riuscita: {message}',
    'aiFill:noValues': 'L\u2019IA non è riuscita a estrarre alcun valore da questa immagine.',
    'aiFill:applied': "L'IA ha compilato {count} campo/i. Puoi annullare in basso.",
    'filter:op.co': 'Contiene',
    'filter:op.nco': 'Non contiene',
    'filter:op.sw': 'Inizia con',
    'filter:op.ew': 'Finisce con',
    'filter:op.eq': 'È uguale a',
    'filter:op.neq': 'Non è uguale a',
    'filter:op.empty': 'È vuoto',
    'filter:op.nempty': 'Non è vuoto',
    'filter:op.in': 'È uno di',
    'filter:op.gt': 'Maggiore di',
    'filter:op.lt': 'Minore di',
    'filter:op.between': 'Tra',
    'filter:searchValues': 'Cerca nella lista…',
    'filter:selectAll': 'Seleziona tutto',
    'filter:noValues': 'Nessun valore trovato',
    'common:newRecord': 'Nuovo {name}',
    'common:editRecord': 'Modifica {name} #{id}',
    'common:themeLight': 'Chiaro',
    'common:themeDark': 'Scuro',
    'common:themeSystem': 'Sistema',
    'common:ok': 'OK',
    'common:select': 'Seleziona…',
    'common:removeItem': 'Rimuovi {title}',
    'common:nSelectedAddMore': '{count} selezionato/i — aggiungi altri',
    'common:pickRecords': 'Scegli record',
    'common:managePickRecords': 'Gestisci selezione ({count})',
    'common:pickRecordsFrom': 'Scegli da {name}',
    'common:draftRestored': 'Bozza non salvata ripristinata',
    'common:undoDraftRestore': 'Annulla',
    'wizard:stepOf': 'Passo {current} di {total}',
    'wizard:products.step1': 'Informazioni di base',
    'wizard:products.step2': 'Prezzi',
    'wizard:products.step3': 'Media e tag',
    'common:invalidValue': 'Valore non valido',
    'common:collapseSidebar': 'Comprimi barra laterale',
    'common:expandSidebar': 'Espandi barra laterale',
    'common:toggleSidebar': 'Attiva/disattiva barra laterale',
    'common:sidebarTitle': 'Barra laterale',
    'common:sidebarNavigation': 'Menu di navigazione',
    'cache:title': 'Cache',
    'cache:description': 'Stato della cache e prestazioni per risorsa su questa replica.',
    'cache:load.error': 'Impossibile caricare le metriche della cache',
    'cache:load.retry': 'Riprova',
    'cache:reset.action': 'Reimposta metriche',
    'cache:reset.loading': 'Reimpostazione metriche cache…',
    'cache:reset.success': 'Metriche cache reimpostate',
    'cache:reset.error': 'Impossibile reimpostare le metriche cache',
    'cache:metric.hitRate': 'Tasso di successo',
    'cache:metric.requests': 'Letture cache',
    'cache:metric.avgCompute': 'Calcolo medio',
    'cache:metric.errors': 'Errori',
    'cache:unit.ms': '{value} ms',
    'cache:quarantine.title': 'Tag in quarantena',
    'cache:quarantine.description': "Questi tag ignorano la cache finché l'invalidazione non riesce.",
    'cache:invalidate.title': 'Invalida cache della risorsa',
    'cache:invalidate.description': 'Elimina elenchi e record della risorsa su tutte le repliche configurate.',
    'cache:invalidate.resource': 'Risorsa',
    'cache:invalidate.action': 'Invalida cache',
    'cache:invalidate.loading': 'Invalidazione cache…',
    'cache:invalidate.success': 'Cache della risorsa invalidata',
    'cache:invalidate.error': 'Impossibile invalidare la cache della risorsa',
    'cache:table.title': 'Metriche per namespace',
    'cache:table.empty': 'Nessuna attività della cache ancora registrata.',
    'cache:instance': 'Replica {id}',
    'cache:table.namespace': 'Namespace',
    'cache:table.resource': 'Risorsa',
    'cache:table.hits': 'Successi',
    'cache:table.misses': 'Mancati',
    'cache:table.computes': 'Calcoli',
    'cache:table.coalesced': 'Raggruppati',
    'cache:table.errors': 'Errori',
  },
}
